import { useEffect, useState, useRef } from 'react';
import { database } from '../config/firebase';
import { ref, onValue, set, remove, serverTimestamp } from 'firebase/database';

export const useTypingIndicator = (userId: string | undefined, userName: string | undefined) => {
    const [typingUsers, setTypingUsers] = useState<string[]>([]);
    const [isTyping, setIsTyping] = useState(false);
    const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const typingRef = ref(database, 'chat/typing');

        const unsubscribe = onValue(typingRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const users = Object.entries(data)
                    .filter(([key, value]: [string, any]) => key !== userId && value.isTyping) // Don't show self
                    .map(([_, value]: [string, any]) => value.userName);
                setTypingUsers(users);
            } else {
                setTypingUsers([]);
            }
        });

        return () => unsubscribe();
    }, [userId]);

    const setTypingStatus = (typing: boolean) => {
        if (!userId || !userName) return;

        const userTypingRef = ref(database, `chat/typing/${userId}`);
        if (typing) {
            set(userTypingRef, {
                isTyping: true,
                userName: userName,
                timestamp: serverTimestamp()
            });
            setIsTyping(true);

            // Clear previous timeout
            if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

            // Auto stop typing after 3 seconds of inactivity
            typingTimeoutRef.current = setTimeout(() => {
                setTypingStatus(false);
            }, 3000);

        } else {
            remove(userTypingRef);
            setIsTyping(false);
            if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        }
    };

    // Cleanup hook
    useEffect(() => {
        return () => {
            if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        };
    }, []);

    return { typingUsers, setTypingStatus };
};


